import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { ButtonStylingModel } from '../button/button-styling.model';
export class FormStylingModel extends CoreStylingModel {
/**
 * Styling for the form
 */
form?: StylingModel;
/**
 * Styling for the table with questions
 */
table?: StylingModel;
/**
 * Styling for the form content
 */
content?: StylingModel;
/**
 * Styling for the form submit section
 */
submitSection?: StylingModel;
/**
 * Styling for submit button
 */
submitButton?: ButtonStylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function FormStylingModel_tsickle_Closure_declarations() {
/**
 * Styling for the form
 * @type {?}
 */
FormStylingModel.prototype.form;
/**
 * Styling for the table with questions
 * @type {?}
 */
FormStylingModel.prototype.table;
/**
 * Styling for the form content
 * @type {?}
 */
FormStylingModel.prototype.content;
/**
 * Styling for the form submit section
 * @type {?}
 */
FormStylingModel.prototype.submitSection;
/**
 * Styling for submit button
 * @type {?}
 */
FormStylingModel.prototype.submitButton;
}

